// extracted by mini-css-extract-plugin
module.exports = {"container":"_408a5b4e","padding":"_29e0ee38","tooltip":"_f5f93b55","fadeIn":"_c2408e48","attention":"_c27b415f","icon":"_58527a5c","icon_attention":"_c5c76f18"};